import { Button } from 'reactstrap';
import { useContext, useEffect, useState, useMemo } from 'react';
import { useReactTable } from '@tanstack/react-table';
import { useHistory } from 'react-router-dom';

import {
    SelectColumnFilter,
    DateRangeColumnFilter,
    dateBetweenFilterFn,
} from '../../services/filters';

import { CampaignContext } from '../../context/campaign';
import { fetchMyCampaign, fetchExpenses } from '../../services/campaign';
import { IExpenseItem, MyCampaignResponse } from '../../types/campaign';
import { formatCurrency } from '../../services/helper';
import TableContainer from '../Campaign/components/TableContainer';
import { CampaignHeaderSection } from '../../shared/components/cards/CampaignItemsCard';
import { renderIcon } from '../../shared/components/icons';

export const FundRequestsTablePage = ({}: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
    const [expenses, setExpenses] = useState<IExpenseItem>();
    const history = useHistory();
    function ExpensesHeaderCard() {
        return (
            <div>
                <h4>Expenses</h4>
                <div
                    className='d-flex justify-content-between'
                    style={{
                        margin: '0 -40px',
                        padding: '8px 40px',
                        backgroundColor: 'rgba(244, 125, 41, 0.1)',
                    }}
                >
                    <Button
                        color='outline-dark'
                        size='sm'
                        onClick={handleSubmitExpenses}
                    >
                        Submit Expenses
                    </Button>
                    <Button
                        color='outline-dark'
                        size='sm'
                        onClick={handleDirectDeposit}
                    >
                        Set Up Direct Deposit
                    </Button>
                </div>
            </div>
        );
    }

    function ExpensesStatusSection() {
        return (
            <div
                className='d-flex justify-content-between'
                style={{
                    margin: '0 -40px',
                    padding: '8px 40px',
                    backgroundColor: 'rgba(244, 125, 41, 0.1)',
                }}
            >
                <div></div>
                <Button color='outline-dark' size='sm' onClick={handleExport}>
                    {renderIcon('download')} Export List
                </Button>
            </div>
        );
    }

    const handleSubmitExpenses = () => {
        console.log('handleSubmitExpenses() TODO');
    };
    const handleDirectDeposit = () => {
        console.log('handleDirectDeposit() TODO');
    };
    const handleExport = () => {
        console.log('handleExport() TODO');
    };

    const data = useMemo(() => {
        if (expenses) {
            console.log('IN DATA', expenses);
            return expenses.items.map((expense) => {
                return {
                    payee: expense.payee,
                    status: expense.date,
                    last_updated: expense.last_updated,
                    items: expense.items,
                    amount: formatCurrency(expense.amount),
                    vendor_id: expense.vendor_id,
                    doc_description: expense.doc_description,
                };
            });
        } else {
            return [];
        }
    }, [expenses]);

    const columns = useMemo(
        () => [
            {
                Header: 'Payee',
                accessorKey: 'payee', // accessor is the "key" in the data
            },
            {
                Header: 'Status',
                accessorKey: 'status',
            },
            {
                Header: 'Last Updated',
                accessorKey: 'last_updated',
                Filter: DateRangeColumnFilter,
                filter: dateBetweenFilterFn,
            },
            {
                Header: 'Items',
                accessorKey: 'items',
            },
            {
                Header: 'Amount',
                accessorKey: 'amount',
            },
            {
                Header: 'Vendor ID',
                accessorKey: 'vendor_id',
            },
            {
                Header: 'Description',
                accessorKey: 'doc_description',
            },
            {
                Header: 'Actions',
                accessorKey: '',
            },
        ],
        []
    );

    useEffect(() => {
        if (!campaign) {
            getMyCampaign();
        }
    }, []);

    useEffect(() => {
        if (campaign) {
            if (!expenses && !loading) {
                setLoading(true);
                getExpenses();
            }
        }
    }, [campaign]);

    const getExpenses = async () => {
        if (campaign) {
            try {
                const campaign_id = campaign.campaignDetail.campaign_id;
                const resp: IExpenseItem = await fetchExpenses(campaign_id);

                setExpenses(resp);
                setLoading(false);
            } catch (e) {
                console.log('getExpenses() e: ', e);
                // Show some error here
            }
        }
    };

    const getMyCampaign = async () => {
        try {
            const resp: MyCampaignResponse = await fetchMyCampaign();
            if (resp.detail && resp.detail === 'Invalid token.') {
                // Delete localStorage token
                localStorage.removeItem('token');
                history.push('/login');
            }
            campaignDispatch({
                type: 'set_campaign',
                payload: resp,
            });
            setLoading(false);
        } catch (e) {
            console.log('getMyCampaign() e: ', e);
            // Show some error here
        }
    };

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useReactTable({ columns, data });

    if (!campaign) {
        return <div>Loading...</div>;
    }

    const { campaignDetail, campaignStats, campaignCoordinator } = campaign;

    return (
        <div className='container__inner'>
            <CampaignHeaderSection
                leftcard={<ExpensesHeaderCard />}
                contact={campaignCoordinator}
            />

            <ExpensesStatusSection />

            <div className='pb-5'>
                <TableContainer
                    columns={columns}
                    data={data}
                    showPaginationComponents={true}
                    showFilterComponents={true}
                />
            </div>
        </div>
    );
};
